import { lazy, LazyExoticComponent } from 'react';
import { HOME } from '../utils/constants/routes';

type JSXComponent = () => JSX.Element;

interface Route {
  to: string;
  path: string;
  component: JSXComponent | LazyExoticComponent<JSXComponent>;
  description: string;
}

const CategoryPage = lazy(() => import('../pages/Category/Category.page'));
const OptionPage = lazy(() => import('../pages/Option/Option.page'));
const FaqPage = lazy(() => import('../pages/Faq/Faq.page'));
const StepPage = lazy(() => import('../pages/Step/Step.page'));
const SearchMatchesPage = lazy(() => import('../pages/SearchMatches/SearchMatches.page'));

const routes: Route[] = [
  {
    to: HOME,
    path: HOME,
    component: CategoryPage,
    description: 'Category Page',
  },
  {
    to: `${HOME}/options/:categoryUrlFriendly`,
    path: `${HOME}/options/:categoryUrlFriendly`,
    component: OptionPage,
    description: 'Option Page',
  },
  {
    to: `${HOME}/options/:categoryUrlFriendly/faqs/:optionUrlFriendly`,
    path: `${HOME}/options/:categoryUrlFriendly/faqs/:optionUrlFriendly`,
    component: FaqPage,
    description: 'Faq Page',
  },
  {
    to: `${HOME}/results/options/:categoryUrlFriendly/faqs/:optionUrlFriendly`,
    path: `${HOME}/results/options/:categoryUrlFriendly/faqs/:optionUrlFriendly`,
    component: FaqPage,
    description: 'Faq Page',
  },
  {
    to: `${HOME}/options/:categoryUrlFriendly/steps/:optionUrlFriendly`,
    path: `${HOME}/options/:categoryUrlFriendly/steps/:optionUrlFriendly`,
    component: StepPage,
    description: 'Step Page',
  },
  {
    to: `${HOME}/options/:categoryUrlFriendly/faqs/steps/:optionUrlFriendly`,
    path: `${HOME}/options/:categoryUrlFriendly/faqs/steps/:optionUrlFriendly`,
    component: StepPage,
    description: 'Step Page',
  },
  {
    to: `${HOME}/results/options/:categoryUrlFriendly/steps/:optionUrlFriendly`,
    path: `${HOME}/results/options/:categoryUrlFriendly/steps/:optionUrlFriendly`,
    component: StepPage,
    description: 'Step Page',
  },
  {
    to: `${HOME}/results`,
    path: `${HOME}/results`,
    component: SearchMatchesPage,
    description: 'Results Page',
  },
];

export default routes;
